import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  viewBox: "0 0 17 17"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "data-name": "info filled",
  d: "M10 7.571a.911.911 0 1 1 .911-.911.911.911 0 0 1-.911.911zm-.607 6.679h1.214V8.786H9.393zM10 1.5a8.5 8.5 0 1 0 8.5 8.5A8.5 8.5 0 0 0 10 1.5z",
  transform: "translate(-1.5 -1.5)",
  style: {"fill":"#f59600","fill-rule":"evenodd"}
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };